import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Register from './components/Register';
import EmployeeList from './components/EmployeeList';
import ManualAttendance from './components/ManualAttendance';
import AttendanceLogs from './components/AttendanceLogs';

function AdminPage() {
  return (
    <div style={{ padding: 20 }}>
      <Register />
      <hr />
      <EmployeeList />
      <hr />
      <AttendanceLogs />
    </div>
  );
}

function HomePage() {
  return (
    <div style={{ padding: 20 }}>
      <ManualAttendance />
    </div>
  );
}

function App() {
  const [allowed, setAllowed] = useState(null);

  useEffect(() => {
    // Call the Node.js endpoint to check if the user is in your Wi-Fi subnet
    fetch('https://attendance-api.elitewebpro.com/api/check-network')
      .then(res => res.json())
      .then(data => setAllowed(data.allowed))
      .catch(err => {
        console.error(err);
        setAllowed(false); // Block if the API fails
      });
  }, []);

  // Still loading
  if (allowed === null) return null;

  // Blocked user (outside Wi-Fi)
  if (!allowed) return <div style={{ width: '100vw', height: '100vh' }}></div>;

  // Allowed user
  return (
    <Routes>
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/" element={<HomePage />} />
    </Routes>
  );
}

export default App;
